/**
 * Phần THUẦN của nút Góp ý (docs/plans/qr-sapa-va-nut-phan-hoi.md, mục 4.2): đổi trang hiện hành sang nhóm màn,
 * kẹp khổ màn, đếm ký tự còn lại, dựng thân gửi lên. Không React, test bằng node.
 */
import {
  chuanHoaLoiNhan,
  type LoaiPhanHoi,
  MAN_PHAN_HOI,
  type ManPhanHoi,
  PHAN_HOI_KHO_MAN_TOI_DA,
  PHAN_HOI_KHO_MAN_TOI_THIEU,
  PHAN_HOI_TOI_DA_KY_TU,
} from '@sapa/shared'

/** Trang hiện hành → nhóm màn gửi kèm. Trang lạ → undefined (bỏ trống, không bịa). */
export function manTuTrang(trang: string): ManPhanHoi | undefined {
  return MAN_PHAN_HOI.find((m) => m === trang)
}

/** Khổ màn (px) gửi kèm, kẹp trong khoảng máy chủ nhận. Số lạ (NaN, vô cực) → undefined. */
export function kepKhoMan(px: number): number | undefined {
  if (!Number.isFinite(px)) return undefined
  return Math.min(PHAN_HOI_KHO_MAN_TOI_DA, Math.max(PHAN_HOI_KHO_MAN_TOI_THIEU, Math.round(px)))
}

/** Số ký tự còn lại để hiện "Còn N ký tự" (không âm). */
export function kyTuConLai(chu: string): number {
  return Math.max(0, PHAN_HOI_TOI_DA_KY_TU - chu.length)
}

/** Chữ trống (hoặc chỉ khoảng trắng / ký tự ẩn) thì không gửi được. */
export function coTheGui(chu: string): boolean {
  return chuanHoaLoiNhan(chu) !== ''
}

export interface ThanGuiPhanHoi {
  loai: LoaiPhanHoi
  noiDung: string
  man?: ManPhanHoi
  banWeb?: string
  khoMan?: number
}

/** Dựng thân gửi: KHÔNG có tenant / SĐT / tên (tiệm + người gửi lấy từ phiên). Không chọn loại → 'khac'. */
export function dungThanPhanHoi(vao: {
  loai: LoaiPhanHoi | null
  chu: string
  trang: string
  banWeb: string | null
  rongManPx: number
}): ThanGuiPhanHoi {
  const man = manTuTrang(vao.trang)
  const kho = kepKhoMan(vao.rongManPx)
  return {
    loai: vao.loai ?? 'khac',
    noiDung: vao.chu,
    ...(man === undefined ? {} : { man }),
    ...(vao.banWeb === null ? {} : { banWeb: vao.banWeb }),
    ...(kho === undefined ? {} : { khoMan: kho }),
  }
}
